export function initialize(module: ng.IModule) {
    module.directive("personDetailsView", personDirective);

    personDirective.$inject = [];
}

function personDirective(): ng.IDirective {
    return {
        scope: {
            vm: "=",
            isReadonly: "="
        },
        restrict: "A",
        template: require("./person.details.directive.html")
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/person.details.directive.ts